import { CSSProperties } from 'react'
import { iconTypes } from './fileIconTypes'
import { ReactComponent as DefaultIcon } from '@/assets/images/icons/files/default.svg'

interface FileIconProps {
  fileExtension: string
  width?: CSSProperties['width']
  isSignature?: boolean
}

const FileIcon = ({ fileExtension, width, isSignature }: FileIconProps) => {
  const IconComponent =
    iconTypes.find(type =>
      type.extensions.includes(
        isSignature ? 'signature' : fileExtension?.toLowerCase(),
      ),
    )?.icon ?? DefaultIcon

  return <IconComponent style={{ width: width ?? '30%' }} />
}

export default FileIcon
